import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { logger } from "@/lib/logger";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Admin · Feaststar";
    // Block search engines from indexing the admin login page
    let meta = document.querySelector('meta[name="robots"]');
    const created = !meta;
    let original = "";
    if (meta) {
      original = meta.getAttribute("content") || "";
    } else {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, nofollow, noarchive, nosnippet");
    return () => {
      if (created) {
        if (meta.parentNode) meta.parentNode.removeChild(meta);
      } else {
        meta.setAttribute("content", original);
      }
    };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      // credentials:'include' tells the browser to accept + store the
      // HttpOnly Set-Cookie from the backend. We deliberately do NOT
      // touch sessionStorage — the token stays out of JavaScript scope.
      const res = await fetch(`${API}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ password }),
      });
      if (res.status === 401) {
        setError("Falsches Passwort.");
        setBusy(false);
        return;
      }
      if (!res.ok) {
        setError("Anmeldung fehlgeschlagen. Bitte später erneut versuchen.");
        setBusy(false);
        return;
      }
      navigate("/admin", { replace: true });
    } catch (err) {
      logger.error("[admin-login] network error:", err);
      setError("Netzwerkfehler. Bitte später erneut versuchen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login-wrap" data-testid="admin-login-page">
      <form onSubmit={onSubmit} className="admin-login-card" data-testid="admin-login-form">
        <div className="admin-login-icon" aria-hidden="true">
          <Lock size={20} strokeWidth={1.75} />
        </div>
        <h1 className="admin-login-title">
          <span className="block italic">Admin-Bereich</span>
        </h1>
        <p className="admin-login-sub">Passwort eingeben, um auf das Dashboard zuzugreifen.</p>

        <label className="admin-login-label">
          <span>PASSWORT</span>
          <input
            type="password"
            required
            autoFocus
            value={password}
            onChange={(ev) => setPassword(ev.target.value)}
            data-testid="admin-password"
            className="field-input"
            placeholder="••••••••"
          />
        </label>

        {error && <div className="notify-error" data-testid="admin-login-error">{error}</div>}

        <button
          type="submit"
          disabled={busy || !password}
          data-testid="admin-login-submit"
          className="btn-primary admin-login-submit"
        >
          {busy ? "Wird geprüft…" : "Anmelden"}
        </button>

        <p className="admin-login-footnote">
          Zugang nur für Betreiber. Bei Verlust des Passworts: Backend-Env neu setzen.
        </p>
      </form>
    </div>
  );
}
